<template>
  <div class="footer">
    <div class="conter">
      <div class="link">
        <div class="lj">
          <div class="tit">友情链接</div>
          <div class="select" @click="onSelect">
            <span>友情链接</span>
            <div class="list" v-if="show">
              <ul>
                <li>
                  <a target="_blank" href="http://www.gov.cn/">中央人民政府</a>
                </li>

                <li>
                  <a target="_blank" href="http://www.hubei.gov.cn/"
                    >湖北省人民政府</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.sasac.gov.cn/"
                    >国务院国资委</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://gzw.hubei.gov.cn/"
                    >湖北省国资委</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="zq">
          <div class="tit">集团网站群</div>
          <div class="select" @click="onSelect1">
            <span>集团网站群</span>
            <div class="list" v-if="show1">
              <ul>
                <li>
                  <a target="_blank" href="https://www.cjtouzi.com/"
                    >长江产业投资集团</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://www.guangjipharm.com/"
                    >湖北广济药业股份有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.masonled.com/"
                    >深圳万润科技股份有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.hbshkj.cn"
                    >湖北双环科技股份有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.yangtze-fund.com/"
                    >长江产业投资私募基金管理有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.cjxdhg.com/"
                    >湖北长江产业现代化工有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.hbssttz.com/"
                    >湖北省生态环保有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.hbcjxc.com/"
                    >湖北省长江新材有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://www.cjtoukai.com.cn/"
                    >湖北长江产业载体投资开发有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="http://cjztyy.com/"
                    >湖北长江产业载体运营管理有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="https://www.hbcjzg.com/index.shtml"
                    >湖北长江产业资产经营管理有限公司</a
                  >
                </li>

                <li>
                  <a target="_blank" href="https://www.hbcjkcfwjt.com/"
                    >湖北长江科创服务集团有限公司</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="footer_menu">
          <ul>
            <li>
              <router-link :to="{ path: '/aboutUs', query: { aboutUsId: '1' } }"
                ><img
                  src="../assets/images/index20231114_23.png"
                  alt=""
                />关于我们</router-link
              >
            </li>
            <li>
              <router-link to="/feedback"
                ><img
                  src="../assets/images/index20231114_21.png"
                  alt=""
                />举报方式</router-link
              >
            </li>
            <li>
              <router-link :to="{ path: '/aboutUs', query: { aboutUsId: '4' } }"
                ><img
                  src="../assets/images/index20231114_24.png"
                  alt=""
                />信息公开</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: '/servicehall', query: { servicehallId: '1' } }"
                ><img
                  src="../assets/images/index20231114_22.png"
                  alt=""
                />服务大厅</router-link
              >
            </li>
          </ul>
        </div>
        <div class="text">
          <span
            ><img
              src="../assets/images/index20231114_25.png"
              alt=""
            />联系电话：027-87257933</span
          >
          <span
            ><img
              src="../assets/images/index20231114_26.png"
              alt=""
            />版权所有：湖北省人才发展集团有限公司</span
          >
          <span
            ><img
              src="../assets/images/index20231114_27.png"
              alt=""
            />备案序号：<a target="_blank" href="https://beian.miit.gov.cn/"
                    >鄂ICP备19012004号-3</a></span
          >
          <span
            ><img
              src="../assets/images/beian.png"
              alt=""
            /><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010602005070" rel="noreferrer" target="_blank">鄂公网安备42010602005070号</a ></span
          >
          <span
            ><img
              src="../assets/images/index20231114_28.png"
              alt=""
            />公司地址：武昌区民主路782号洪广宝座第12,24层</span
          >
        </div>
        <div class="ewm">
          <p>扫描二维码关注<br />湖北省人才发展集团<br />微信公众号</p>
          <img
            src="../assets/images/a58875b9-c505-4abc-83ce-eba885e56c04.png_186xaf.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      show1: false
    };
  },
  methods: {
    onSelect() {
      this.show = !this.show;
      this.show1 = false;
      this.$emit("son", this.show);
    },
    onSelect1() {
      this.show = false;
      this.show1 = !this.show1;
      this.$emit("son", this.show1);
    }
  }
};
</script>
<style lang="less" scoped>
/***默认让所有浏览器出现右边滚动条****/
html {
  font-size: 16px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

/***默认清除浮动****/
body {
  font-family: "微软雅黑", "sans-serif", "Arial";
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

.conter {
  max-width: 70%;
  margin: 0 auto;
  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1;
  -o-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-name: fadeInUp;
  -moz-animation-name: fadeInUp;
  -o-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

.footer {
  height: auto;
  padding: 5em 0 8.5em;
  background: url("../assets/images/index20231114_32.png") left bottom no-repeat;
  background-size: 100% auto;
}

.footer .conter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.footer .link {
  width: 25.6666%;
  margin-right: 5%;
}

.footer .link .tit {
  font-size: 1.3125em;
  color: #333;
}

.footer .link .select {
  margin-top: 1.625em;
  width: 100%;
  padding: 0.625em 1em;
  box-sizing: border-box;
  border: 1px solid #939393;
  position: relative;
  cursor: pointer;
}

.footer .link .select span {
  color: #6f6f6f;
  font-size: 1.125em;
}

.footer .link .select:after {
  content: "";
  position: absolute;
  border-left: 0.5em solid transparent;
  border-right: 0.5em solid transparent;
  border-top: 0.5em solid #cea769;
  top: calc((100% - 0.5em) / 2);
  right: 0.8125em;
  transition: all 0.5s;
}

.footer .link .select .list {
  // display: none;
  position: absolute;
  bottom: calc(100% + 1px);
  left: 0;
  width: 100%;
  height: 11.4em;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 -5px 5px 0 rgba(255, 255, 255, 0.3);
  z-index: 100;
}

/* .footer .link .select:hover .list {
  display: flex;
} */

.footer .link .select ul {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 0.25em 0.75em 0.25em 1.125em;
  border-radius: 0.5em;
  border: 0.1em solid #e0e0e0;
  border-bottom: none;
}

.footer .link .select ul::-webkit-scrollbar {
  background: #ededed;
  width: 0.375em;
}

.footer .link .select ul::-webkit-scrollbar-thumb {
  background: #a0a0a0;
}

.footer .link .select ul li {
  width: 100%;
}

.footer .link .select ul a {
  font-size: 1.125em;
  padding: 0.7222em 0;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-bottom: 1px solid #dcdcdc;
  color: #333;
}

.footer .link .select ul a:hover {
  color: #cda667;
}

.footer .link .select.show .list {
  display: block;
}

.footer .link .select.show:after {
  transform: rotate(180deg);
}

.footer .link .lj {
  margin-bottom: 3.625em;
}

.footer .info {
  width: 69.3334%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  gap: 1.5em;
}

.footer .info .footer_menu {
  width: 100%;
  flex-basis: 100%;
  margin-bottom: 1.225em;
}

.footer .info .footer_menu ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
}

.footer .info .footer_menu a {
  display: flex;
  align-items: center;
  font-size: 1.225em;
  white-space: nowrap;
}

.footer .info .footer_menu img {
  margin-right: 0.5em;
  height: 1.2285em;
}

.footer .info .text span {
  display: flex;
  align-items: center;
  padding: 0.45em 0;
  font-size: 1.075em;
  color: #7e7e7e;
  background: #f9f9f9;
  font-family: SHSCR, "sans-serif", "Arial";
}

.footer .info .text {
  flex-basis: 60%;
  background: #f9f9f9;
  padding: 0.5em 1.6em;
  box-sizing: border-box;
}

.footer .info .text span img {
  width: 1.2333em;
  margin-right: 0.5em;
}

.footer .info .ewm {
  text-align: center;
  box-sizing: border-box;
  background: #f9f9f9;
  flex-basis: calc(40% - 1.5em);
  display: flex;
  align-items: center;
  line-height: 1.6em;
  justify-content: center;
  color: #7e7e7e;
}

.footer .info .ewm p span {
  display: block;
}

.footer .info .ewm img {
  margin-left: 0.6875em;
  width: 5.25em;
}

.footer .info .footer_menu ul li:hover img {
  -webkit-animation-duration: 0.7s;
  -moz-animation-duration: 0.7s;
  -o-animation-duration: 0.7s;
  animation-duration: 0.7s;
  -webkit-animation-name: rateRight;
  -moz-animation-name: rateRight;
  -o-animation-name: rateRight;
  animation-name: rateRight;
  -webkit-animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -o-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    /* transform:translateX(100%);
	*/
  }

  100% {
    opacity: 1;
    /* transform:translateX(0) */
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(50%);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes rateRight {
  0% {
    transform: rotate(30deg);
  }

  33% {
    transform: rotate(0deg);
  }

  66% {
    transform: rotate(30deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@media (max-width: 1300px) {
  html {
    font-size: 14px;
  }

  .top .logo {
    width: 11.136vw;
    margin-left: 2%;
  }

  .footer {
    padding-bottom: 11em;
  }

  .footer .link {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .footer .link > div {
    width: 48%;
  }

  .footer .info {
    width: 100%;
  }
}

.footer .conter .info .ewm p {
  /* width: 52%; */
  text-align: center;
}
</style>
